import authInstance from "../Interceptor/interceptor";

export const addWardEffect = (formData) => {
  return authInstance.post("/wards/add", formData);
};

export const deleteWardEffect = (id) => {
  return authInstance.delete(`/wards/delete/${id}`);
};

export const editWardEffect = (data) => {
  const {
    block_id,
    floor_id,
    id,
    visitor_end_time,
    visitor_start_time,
    ward_name,
    ward_status,
    ward_type,
    weekday_id,
  } = data;
  const fromData = {
    block_id,
    floor_id,
    visitor_end_time,
    visitor_start_time,
    ward_name,
    ward_status,
    ward_type,
    weekday_id,
  };
  return authInstance.put(`/wards/update/${id}`, fromData);
};

export const viewWardEffect = () => {
  return authInstance.get("/Ward/list");
};

export const listWardEffect = ({ blockId, floorId, pageNo }) => {
  return authInstance.get(
    `/wards/blockbylist?block_id=${blockId}&pagination_required=false&pagesize=10&pageNo=${pageNo}&floor_id=${floorId}`
  );
};

export const listAllWardEffect = (pageNo) => {
  return authInstance.get(
    `/wards/wardslist?pageNo=${pageNo}&pagesize=10&pagination_required=false`
  );
};
export const listWardEffectByWeekId = (weekId) => {
  return authInstance.get(`/wards/getwardsbyweekdayid?weekday_id=${weekId}`);
};

export const listWardAllEffect = (pageNo) => {
  return authInstance.get(
    `/wards/wardslist?pageNo=${pageNo}&pagesize=10&pagination_required=true`
  );
};
